import { Box, Typography } from "@mui/material";
import { FC } from "react";
import { dotStyle, loaderContainer, messageStyle } from "./styles";
import { useThemeContext } from "../../../globalContext/global-context";

type TransitionLoaderProps = {
  id: string;
  message?: string;
  announcement?: string;
  color?: string;
  messageFirst?: boolean;
};

const TransitionLoader: FC<TransitionLoaderProps> = ({
  id,
  message,
  announcement,
  color,
  messageFirst,
}) => {
  const { globalObject } = useThemeContext();
  const theme = globalObject.themeData.normalizedTheme;
  return (
    <Box
      aria-label={announcement ?? message ?? theme.copy.status.loading}
      aria-live="polite"
      data-testid={id}
      role="status"
      sx={loaderContainer(theme, color, messageFirst)}
    >
      <Box
        aria-hidden="true"
        sx={{ display: "flex", gap: `${theme.tokens.spacing["1"]}px` }}
      >
        {[0, 1, 2].map((index) => (
          <Box key={index} sx={dotStyle(theme, index)} />
        ))}
      </Box>
      {message && (
        <Typography
          aria-hidden={announcement ? "true" : undefined}
          sx={messageStyle(theme)}
        >
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default TransitionLoader;
